import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TTnAOrderTemplateState } from './tna-order-template.models';

export const getTnAOrderTemplateState = (state: TPlani8State) => state.tnaOrderTemplateInfo;

export const getTnAOrdertemplatesInfo = createSelector(
  getTnAOrderTemplateState,
  (state: TTnAOrderTemplateState) => state.tnaOrderTemplateInfo,
);

export const getShowTnAOrderTemplatesLoader = createSelector(
  getTnAOrderTemplateState,
  (state: TTnAOrderTemplateState) => state.showTnAOrderTemplatesLoader,
);
